module.exports = __webpack_public_path__ + "assets/img/system-point-banner2.5d08a830.png";